import React from "react";
import { Close, Menu as Menu$1 } from "@mui/icons-material";
import { useMediaQuery, AppBar, Toolbar, IconButton, Typography, Drawer, Divider } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
import "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
import "@mui/material/colors";
import "@mui/material/locale";
import "@mui/material/styles";
import { useCustomTheme } from "../../style/hooks.js";
const useStyles = makeStyles()((theme) => ({
  menuContainer: {
    "& .MuiDivider-root": {
      margin: theme.spacing(0, 1),
      borderColor: theme.palette.secondary.light
    }
  },
  menuFooter: {
    marginTop: "auto"
  },
  // mobile classes
  menuAppBar: {
    left: 0,
    backgroundColor: theme.palette.background.paper,
    zIndex: theme.zIndex.tooltip
  },
  menuAppBarButton: {
    marginRight: theme.spacing(2),
    marginLeft: 0
  },
  menuDrawerPaperMobile: {
    overflowX: "hidden",
    marginTop: theme.mixins.toolbar.minHeight,
    background: theme.palette.background.paper,
    width: theme.custom.sideBarWidth,
    height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`
  },
  // desktop classes
  menuDrawerPaper: {
    overflowX: "hidden",
    width: theme.custom.sideBarWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuDrawerPaperClosed: {
    width: theme.custom.sideBarMinimizedWidth
  },
  menuHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(3, 2, 2, 3)
  },
  menuHeaderClosed: {
    padding: theme.spacing(3, 2, 2)
  }
}));
function Menu({ name, isStick, onIsStickChange, children, footer, onHoverChanged }) {
  const theme = useCustomTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { classes, cx } = useStyles();
  const [hovered, setHovered] = React.useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  function handleMouseOver() {
    if (!isStick) {
      setHovered(true);
      if (onHoverChanged) {
        onHoverChanged(true);
      }
    }
  }
  function handleMouseLeave() {
    if (!isStick) {
      setHovered(false);
      if (onHoverChanged) {
        onHoverChanged(false);
      }
    }
  }
  function handleBurgerClick() {
    setMobileOpen(!mobileOpen);
  }
  const isStickOrHovered = isStick || hovered;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isMobile && /* @__PURE__ */ React.createElement(AppBar, { position: "fixed", className: classes.menuAppBar, elevation: 0 }, /* @__PURE__ */ React.createElement(Toolbar, null, /* @__PURE__ */ React.createElement(IconButton, { color: "default", edge: "start", onClick: handleBurgerClick, className: classes.menuAppBarButton }, mobileOpen ? /* @__PURE__ */ React.createElement(Close, null) : /* @__PURE__ */ React.createElement(Menu$1, null)), /* @__PURE__ */ React.createElement(Typography, { variant: "h6", color: "textPrimary" }, /* @__PURE__ */ React.createElement(LocalizedText, { label: name })))), /* @__PURE__ */ React.createElement("nav", null, isMobile ? /* @__PURE__ */ React.createElement(
    Drawer,
    {
      classes: { paper: cx(classes.menuContainer, classes.menuDrawerPaperMobile) },
      variant: "temporary",
      anchor: theme.direction === "rtl" ? "right" : "left",
      open: mobileOpen,
      onClose: handleBurgerClick,
      ModalProps: { keepMounted: true }
    },
    children,
    footer && /* @__PURE__ */ React.createElement("div", { className: classes.menuFooter }, footer)
  ) : /* @__PURE__ */ React.createElement(
    Drawer,
    {
      "data-testid": "sidebarDrawer",
      variant: "permanent",
      classes: {
        paper: cx(classes.menuContainer, classes.menuDrawerPaper, !isStickOrHovered && classes.menuDrawerPaperClosed)
      },
      onMouseOver: handleMouseOver,
      onMouseLeave: handleMouseLeave
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(classes.menuHeader, !isStickOrHovered && classes.menuHeaderClosed),
        "data-testid": "sidebarDrawerHeader"
      },
      isStickOrHovered ? /* @__PURE__ */ React.createElement(Typography, { variant: "h6" }, /* @__PURE__ */ React.createElement(LocalizedText, { label: name })) : null,
      /* @__PURE__ */ React.createElement(
        IconButton,
        {
          "data-testid": isStick ? "sidebarDrawerUnpin" : "sidebarDrawerPin",
          size: "medium",
          onClick: onIsStickChange
        },
        /* @__PURE__ */ React.createElement("span", { className: isStick ? CustomIcon.UnpinOutline : CustomIcon.PinOutline })
      )
    ),
    /* @__PURE__ */ React.createElement(Divider, null),
    children,
    footer && /* @__PURE__ */ React.createElement("div", { className: classes.menuFooter }, footer)
  )));
}
export {
  Menu
};
//# sourceMappingURL=Menu.js.map
